export default function LocationService(sessionService) {
    'ngInject';

            return {
                getPreviousHash,
                getSavedHash,
                saveHash,
                parseUrlParams,
            };

            function parseUrlParams(stringUrl) {
                const urlRegex = /([^?=&]+)(=([^&]*))?/g;
                const parsedParams = {};
                stringUrl.replace(urlRegex, function($0, $1, $2, $3) {
                        if (!parsedParams.hasOwnProperty($1)) {
                            parsedParams[$1] = decodeURIComponent($3);
                        } else if (angular.isArray(parsedParams[$1])) {
                                parsedParams[$1].push(decodeURIComponent($3));
                            } else {
                                parsedParams[$1] = [parsedParams[$1], decodeURIComponent($3)];
                            }
                    }
                );
                return parsedParams;
            }

            function getPreviousHash() {
                const lastState = getSavedHash();
                const splittedHash = lastState.split('/');
                let isFearch = lastState.split('/');
                let result = '';
                if (splittedHash.length > 3) {
                    isFearch = splittedHash[3].indexOf('results');

                    if (isFearch >= 0) {
                        result = lastState.slice(0, lastState.indexOf('results') - 1);
                    } else {
                        result = lastState;
                    }
                } else {
                    result = lastState;
                }
                return result;
            }

            function getSavedHash() {
                return sessionService.getSessionItem('lastState');
            }

            function saveHash(hash) {
                return sessionService.setSessionItem('lastState', hash);
            }
}



// WEBPACK FOOTER //
// ./src/app/services/location-service.js